(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["backer-choice-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll("[data-mtk-backer-choice]");

    roots.forEach((root) => {
      const form = root.querySelector("[data-mtk-backer-choice-form]");
      const refundPanel = root.querySelector("[data-refund-panel]");
      const payoutMethod = root.querySelector("[data-payout-method]");
      const payoutDetails = root.querySelector("[data-payout-details]");
      const formError = root.querySelector("[data-form-error]");
      const formStatus = root.querySelector("[data-form-status]");
      const submitButton = root.querySelector("[data-submit-button]");
      const tokenField = root.querySelector("[data-token-field]");
      const choiceLinkField = root.querySelector("[data-choice-link-field]");
      const urlEmailField = root.querySelector("[data-url-email-field]");
      const urlOrderField = root.querySelector("[data-url-order-field]");
      const emailField = root.querySelector("[data-email-field]");
      const orderField = root.querySelector("[data-order-field]");
      const amountField = root.querySelector("[data-amount-field]");
      const params = new URLSearchParams(window.location.search);
      const webhookUrl = root.dataset.webhookUrl || "";

      tokenField.value = params.get("t") || "";
      choiceLinkField.value = window.location.href;
      urlEmailField.value = params.get("email") || "";
      urlOrderField.value = params.get("order") || "";

      if (params.get("email")) emailField.value = params.get("email");
      if (params.get("order")) orderField.value = params.get("order");
      if (params.get("amount")) amountField.value = params.get("amount");

      const selectedIntent = () => form.querySelector("input[name='intent']:checked")?.value || "";

      const syncRefundFields = () => {
        const isRefund = selectedIntent() === "refund";
        refundPanel.classList.toggle("is-visible", isRefund);
        payoutMethod.required = isRefund;
        payoutDetails.required = isRefund;

        if (!isRefund) {
          payoutMethod.value = "";
          payoutDetails.value = "";
          formError.classList.remove("is-visible");
        }
      };

      form.addEventListener("change", syncRefundFields);

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        formError.classList.remove("is-visible");
        formStatus.textContent = "";

        if (!webhookUrl) {
          formStatus.textContent = "This form is not connected yet. Please contact Musical Tea Kettle support.";
          return;
        }

        if (selectedIntent() === "refund" && (!payoutMethod.value || !payoutDetails.value.trim())) {
          formError.classList.add("is-visible");
          return;
        }

        const payload = Object.fromEntries(new FormData(form).entries());
        submitButton.disabled = true;
        submitButton.textContent = "Submitting...";

        try {
          await fetch(webhookUrl, {
            method: "POST",
            mode: "no-cors",
            headers: { "Content-Type": "text/plain;charset=utf-8" },
            body: JSON.stringify(payload)
          });

          form.reset();
          syncRefundFields();
          formStatus.textContent = "Your choice has been recorded. Thank you.";
        } catch (error) {
          formStatus.textContent = "We could not submit this just now. Please try again in a moment.";
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = "Submit my choice";
        }
      });

      syncRefundFields();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
